import { TableColumn } from '@/typing';
import { getDate, getDateTime, getTime2 } from '@/utils/function';
export default (current_org: any) => {
  const None = null;
  const True = true;
  const False = false;
  const baseColumns: TableColumn[] = [
    {
      title: '序号',
      dataIndex: 'index',
      width: 50,
      fixed: 'left',
    },
    {
      title: 'ID',
      width: 150,
      dataIndex: 'id',
      checked: false,
      resizable: true,
    },
    {
      title: '发生时间',
      width: 150,
      dataIndex: 'create_time',
      checked: true,
      resizable: true,
      content: (record: any, text: any) => getDateTime(text),
    },
    {
      title: '接口url',
      width: 150,
      dataIndex: 'api_url',
      checked: true,
      resizable: true,
    },
    {
      title: '接口名称',
      width: 150,
      dataIndex: 'api_name',
      checked: true,
      resizable: true,
    },
    {
      title: '用户id',
      width: 150,
      dataIndex: 'person_id',
      checked: true,
      resizable: true,
    },
    {
      title: '用户名称',
      width: 150,
      dataIndex: 'person_name',
      checked: true,
      resizable: true,
    },
    {
      title: '日志等级',
      width: 150,
      dataIndex: 'level',
      checked: true,
      resizable: true,
    },
    {
      title: '表名称',
      width: 150,
      dataIndex: 'model_name',
      checked: true,
      resizable: true,
    },
    {
      title: '日志',
      width: 650,
      dataIndex: 'log',
      checked: true,
      resizable: true,
    },

    {
      title: '数据id',
      width: 150,
      dataIndex: 'model_id',
      checked: true,
      resizable: true,
    },
  ];

  return {
    baseColumns: baseColumns,
  };
};
